import React from 'react';
// Importa useNavigate de react-router-dom
import { useNavigate } from 'react-router-dom';
import './TeamPage.css'; // Necesitarás crear y estilizar este archivo CSS

// --- Componente TeamPage ---
const TeamPage = () => {
    // Inicializa el hook useNavigate
    const navigate = useNavigate();

    // --- DATOS DE EJEMPLO - REEMPLAZA CON LA INFORMACIÓN REAL ---
    const specialists = [
        {
            id: 1,
            name: "Dra. Raquel Navarro", // b) Nombre
            title: "Especialista en Patología Oncológica", // c) Especialidad
            img: "/images/team/generic.jpeg", // a) Foto (Ruta desde public/) - CAMBIA EL NOMBRE DEL ARCHIVO
            bio: "" // d) Semblanza
        },
        {
            id: 2,
            name: "Dra. [Nombre Apellido 2]", // b) Nombre
            title: "[Especialidad Principal 2]", // c) Especialidad
            img: "/images/team/generic.jpeg", // a) Foto - CAMBIA EL NOMBRE DEL ARCHIVO
            bio: "Aquí va la semblanza de la Dra. 2. Describe su formación, años de experiencia, áreas de enfoque (ej. cirugía conservadora, reconstrucción), y su filosofía de atención centrada en la paciente." // d) Semblanza
        },
        {
            id: 3,
            name: "Ft. Adriana Cruz Sánchez", // b) Nombre
            title: "Lic. en Fisioterapia, Esp. en Rehabilitación Oncológica", // c) Especialidad (Título más completo)
            img: "/images/team/ft-adriana-cruz.jpg", // a) Foto - Asegúrate que el nombre del archivo sea correcto
            // d) Semblanza (Texto único y combinado)
            bio: "Ft. Adriana Cruz Sánchez es Licenciada en Medicina Física y Rehabilitación, egresada de la UVP, con especialidad en Rehabilitación Oncológica. Cuenta con experiencia en rehabilitación general adquirida en el ISSSTE de Puebla, y se ha enfocado específicamente en la rehabilitación de pacientes con cáncer de mama dentro del programa CIPMa del ISSSTE, que fue un programa de atención integral para las pacientes con cancer de mama. Ha colaborado en proyectos de investigación sobre rehabilitación oncológica, presentados en congresos de la Sociedad Española de Patología Mamaria (SESPM), y es miembro activo de la Asociación Mexicana de Mastología (AMM). Su práctica está centrada en mejorar la calidad de vida, la movilidad y el manejo de secuelas post-tratamiento, como el linfedema."
        },
        {
            id: 4,
            name: "Dra. [Nombre Apellido 4]", // b) Nombre
            title: "[Especialidad Principal 4, ej: Radióloga especialista en Mama]", // c) Especialidad
            img: "/images/team/dra-nombre-apellido-4.jpg", // a) Foto - CAMBIA EL NOMBRE DEL ARCHIVO
            bio: "Semblanza de la Dra. 4. Puedes destacar su experiencia en interpretación de mastografías, ultrasonidos mamarios, y realización de biopsias guiadas por imagen. Menciona certificaciones o roles relevantes." // d) Semblanza
        },
        {
            id: 5,
            name: "Dra. [Nombre Apellido 5]", // b) Nombre
            title: "[Especialidad Principal 5, ej: Ginecóloga Oncologa]", // c) Especialidad
            img: "/images/team/dra-nombre-apellido-5.jpg", // a) Foto - CAMBIA EL NOMBRE DEL ARCHIVO
            bio: "Semblanza de la Dra. 5. Detalla su experiencia en el manejo integral (diagnóstico, tratamiento quirúrgico, seguimiento) del cáncer ginecológico y mamario. Resalta su enfoque multidisciplinario." // d) Semblanza
        },
        // Puedes añadir más especialistas si es necesario, siguiendo la misma estructura
    ];

    // Datos de ejemplo para otros miembros del equipo (opcional)
    const supportTeam = [
         //{
         //    id: 6,
         //    name: "[Nombre Apellido Coordinador/a]",
         //    title: "[Puesto, ej: Coordinadora de Pacientes / Navegadora]",
         //    img: "/images/team/coord-nombre-apellido.jpg", // CAMBIA EL NOMBRE DEL ARCHIVO
         //    bio: "Responsable de acompañar a las pacientes durante su ruta diagnóstica, agendar citas, resolver dudas administrativas y asegurar una experiencia fluida y humana."
         //},
        // Añadir más si aplica
    ];
    // --- FIN DATOS DE EJEMPLO ---

    // --- Función para manejar error de carga de imagen (AJUSTADA) ---
    const handleImageError = (e) => {
        // Solo intenta establecer la fuente genérica si aún no es la fuente genérica
        const fallbackSrc = "/images/team/generic.jpeg"; // <-- RUTA A TU IMAGEN GENÉRICA
        // Compara la URL completa actual con la URL completa del fallback
        if (e.target.src !== window.location.origin + fallbackSrc) {
            e.target.onerror = null; // Previene bucles si la genérica también falla
            e.target.src = fallbackSrc;
        }
    };


    return (
        <div className="team-page-container"> {/* Clase principal para estilos */}

            {/* --- INICIO: Botón de Volver --- */}
            <div className="back-button-container">
                <button className="back-button" onClick={() => navigate('/landing')}>
                    <span role="img" aria-label="Flecha izquierda">←</span> Volver
                </button>
            </div>
            {/* --- FIN: Botón de Volver --- */}

            <h1>Nuestro Equipo de Salud Especializado</h1>
            <p className="team-intro">
                Conoce al grupo de profesionales altamente calificadas y comprometidas con tu salud mamaria.
                Nuestra experiencia combinada asegura un diagnóstico preciso y un acompañamiento humano en cada paso.
            </p>

            <section className="specialists-section">
                <h2>Médicas Especialistas</h2>
                <div className="specialists-grid"> {/* Contenedor para las tarjetas de especialistas */}
                    {specialists.map(specialist => (
                        <div key={specialist.id} className="specialist-profile-card"> {/* Tarjeta individual */}
                            {/* a) Foto */}
                            <img
                                src={specialist.img} // Ruta desde public/images/team/
                                alt={`Foto ${specialist.name}`}
                                className="specialist-photo-full" // Estilo para la foto (necesitarás definirlo en TeamPage.css)
                                onError={handleImageError} // Manejador para imagen genérica
                            />
                            <div className="specialist-info"> {/* Contenedor para la info */}
                                {/* b) Nombre */}
                                <h3>{specialist.name}</h3>
                                {/* c) Especialidad */}
                                <h4>{specialist.title}</h4>
                                {/* d) Semblanza */}
                                <p>{specialist.bio}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Sección Opcional para otros miembros del equipo */}
            {supportTeam.length > 0 && (
                <section className="support-team-section">
                    <h2>Equipo de Apoyo</h2>
                    <div className="support-team-grid"> {/* Contenedor para tarjetas de apoyo */}
                        {supportTeam.map(member => (
                            <div key={member.id} className="support-member-card"> {/* Tarjeta individual */}
                                <img
                                    src={member.img} // Ruta desde public/images/team/
                                    alt={`Foto ${member.name}`}
                                    className="support-photo" // Estilo para la foto (necesitarás definirlo en TeamPage.css)
                                    onError={handleImageError} // Manejador para imagen genérica
                                />
                                <div className="support-info"> {/* Contenedor para la info */}
                                    <h3>{member.name}</h3>
                                    <h4>{member.title}</h4>
                                    <p>{member.bio}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            )}

             {/* Enlace para volver (opcional, ya tenemos uno arriba) */}
             {/* <div style={{ textAlign: 'center', marginTop: '40px' }}>
                 <a href="/" className="landing-button">Volver a la Página Principal</a>
             </div> */}

        </div>
    );
};

export default TeamPage;
